export default {
  'HAUX Tech': '#33B6AE',
  'HAUX Fit': '#FF9431',
  'HAUX Training': '#ECC332',
  'HAUX Nutri': '#e86e84',
  'HAUX Multispace': '#B082D4',
};
